export default __webpack_public_path__ + "static/impacts-67ebf8de24dbdce468b745eb80279f63.png";